import styled from 'styled-components'
import { Link } from 'gatsby'

export const StyledFixedContainer = styled.div`
	position: fixed;
	width: 100%;
	top: 0;
	z-index: 11;
	left: 0;
	background-color: #ffffff;
	box-shadow: 20px 10px 73px 0 rgba(14, 14, 14, 0.12);
	transition: top 0.3s;
	${({ headerBackground }) =>
		!headerBackground &&
		`
    background-color: transparent;
    box-shadow: inherit;
  `}
`

export const StyledHeaderMinContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 0 auto;
	max-width: 1440px;
	box-sizing: border-box;
	padding: 0 155px;
	z-index: 11;
	@media (max-width: 1440px) {
		padding-left: 22px;
		padding-right: 22px;
	}
`

export const StyledButton = styled.div`
	button {
		padding: 11px 28px;
	}
`

export const StyledRightContainer = styled.div``
export const StyledMenuItems = styled.div`
	display: grid;
	grid-auto-flow: column;
	grid-column-gap: 38px;
	align-items: center;
	@media (max-width: 1020px) {
		display: none;
	}
`

export const StyledLeftContainer = styled.div`
	display: grid;
	grid-auto-flow: column;
	grid-column-gap: 93px;
	align-items: center;
	padding: 12px 0;
`

export const StyledLink = styled.a`
	font-family: 'tbc-Bold', Arial, Helvetica, sans-serif;
	font-size: 14px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: normal;
	color: #ffffff;
	cursor: pointer;
	text-decoration: none;
`

export const StyledSignIn = styled.div``

export const StyledTextButton = styled.a`
	font-family: 'tbc-Bold', Arial, Helvetica, sans-serif;
	border: none;
	background: none;
	cursor: pointer;
	outline: none;
	text-decoration: none;
	transition: 0.3s;
	font-size: 14px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: normal;
	color: #182372;
	:hover {
		color: #1e67d3;
	}
`

export const StyledRightContainerResponsive = styled.div`
	display: none;
	grid-auto-flow: column;
	grid-column-gap: 26px;
	align-items: center;
	@media (max-width: 992px) {
		display: grid;
	}
`
export const StyledRightContainerInner = styled.div`
	display: grid;
	grid-auto-flow: column;
	align-items: center;
	grid-column-gap: 38px;
	@media (max-width: 992px) {
		display: none;
	}
`

export const StyledBlogLink = styled(Link)`
	font-family: 'tbc-Bold', sans-serif;
	font-size: 16px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: normal;
	color: ${p => p.maincolor};
	border: none;
	text-transform: capitalize;
	background: none;
	cursor: pointer;
	outline: none;
	text-decoration: none;
	transition: 0.3s;
	:hover {
		color: #89c35c;
	}
`
export const StyledBtnContainer = styled.div``
